import { Priority } from "../../../../../../../utils/enums/priority"


const formatFilter = {
  search: 'search',
  createYear: "year",
  month: 'month',
  from: "start_date",
  to: "end_date",
  status: 'status',
}

const providers = [
    { label: "Proveedor 1", value: 1 },
    { label: "Proveedor 2", value: 2 },
    { label: "Proveedor 3", value: 3 },
    { label: "Proveedor 4", value: 4 },
    { label: "Proveedor 5", value: 5 },
    { label: "Proveedor 6", value: 6 },
    { label: "Proveedor 7", value: 7 },
    { label: "Proveedor 8", value: 8 },
    { label: "Proveedor 9", value: 9 },
    { label: "Proveedor 10", value: 10 },
    { label: "Proveedor 11", value: 11 },
    { label: "Proveedor 12", value: 12 },
    { label: "Proveedor 13", value: 13 },
    { label: "Proveedor 14", value: 14 },
    { label: "Proveedor 15", value: 15 },
]

const priorities = [
  {label: 'Urgente', value: Priority.URGENT},
  {label: 'Alta', value: Priority.HIGH},
  {label: 'Media', value: Priority.MEDIUM},
  {label: 'Baja', value: Priority.LOW}
]


export {
  formatFilter,
  providers,
  priorities
}